export const pertuntas: object = {
  "PG1001": {
    "title": "Pergunta Repetida",
    "text": "A pergunta inserida já existe em nosso banco de dados"
  }
}
